// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 交易信号 GET /cd-adviser/strategy/selection-stock/info */
export async function cdAdviserStrategySelectionStockInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.cdAdviserStrategySelectionStockInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultCdStrategySignalResp>('/cd-adviser/strategy/selection-stock/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
